// This file was automatically generated from appchart.refpanel.meds.html.
// Please don't edit this file by hand.

goog.provide('el8.template.appchart.refpanel.meds');

goog.require('soy');
goog.require('soy.StringBuilder');
goog.require('el8.template.ptdata.model.dcMedOrder');
goog.require('el8.template.ptdata.model.medOrder');
goog.require('el8.template.ptdata.model.medOrderThread');


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.meds.order = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  if (opt_data.item.modelClass == 'MedOrder') {
    el8.template.appchart.refpanel.meds.medOrder(opt_data, output);
  } else if (opt_data.item.modelClass == 'DiscontinueMedOrder') {
    el8.template.appchart.refpanel.meds.dcMedOrder(opt_data, output);
  }
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.meds.thread = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="meds_refpanel_', soy.$$escapeHtml(opt_data.item.id), '" class="med-item', (opt_data.hasActions) ? ' el8ItemHover' : '', ' am-highlight thread-actions-trigger" data-id="', soy.$$escapeHtml(opt_data.item.id), '" data-type="thread"><div class="el8ItemCount">', soy.$$escapeHtml(opt_data.num), '</div>');
  if (opt_data.hasActions) {
    output.append('<div class="actions-button el8ItemButtonContainer">');
    el8.template.appchart.refpanel.meds.actionButton_(null, output);
    output.append('</div>');
  }
  output.append('<div class="el8DateYrMM el8ItemWithCount">', (soy.$$escapeHtml(opt_data.shortStartDate)? el8.service.tz.soyShortDate(soy.$$escapeHtml(opt_data.shortStartDate)) : ''), '</div><p class="el8ItemWithDate">');
  el8.template.ptdata.model.medOrderThread.summary(soy.$$augmentData(opt_data.item, {hasTrigger: opt_data.hasActions}), output);
  output.append('</p></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.meds.medOrder = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="meds_refpanel_', soy.$$escapeHtml(opt_data.item.id), '" class="med-item', (opt_data.hasActions) ? ' el8ItemHover' : '', ' am-highlight order-actions-trigger" data-id="', soy.$$escapeHtml(opt_data.item.id), '" data-type="med-order">');
  if (opt_data.hasActions) {
    output.append('<div class="el8ItemButtonContainer">');
    el8.template.appchart.refpanel.meds.actionButton_(null, output);
    output.append('</div>');
  }
  output.append('<div class="el8DateYrMM', (opt_data.item.latestExternalFulfillment && opt_data.item.latestExternalFulfillment.isCancelled) ? ' el8Strike' : '', '">', (soy.$$escapeHtml(opt_data.startDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.startDate)) : ''), '</div><p class="el8ItemWithDate">');
  el8.template.ptdata.model.medOrder.refPanelSummary(soy.$$augmentData(opt_data.item, {hasTrigger: opt_data.hasActions}), output);
  output.append('</p></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.meds.dcMedOrder = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<li id="meds_refpanel_', soy.$$escapeHtml(opt_data.item.id), '" class="med-item', (opt_data.hasActions) ? ' el8ItemHover' : '', ' am-highlight order-actions-trigger" data-id="', soy.$$escapeHtml(opt_data.item.id), '" data-type="dc-med-order">');
  if (opt_data.hasActions) {
    output.append('<div class="el8ItemButtonContainer">');
    el8.template.appchart.refpanel.meds.actionButton_(null, output);
    output.append('</div>');
  }
  output.append('<div class="el8DateYrMM">', (soy.$$escapeHtml(opt_data.dcDate)? el8.service.tz.soyDate(soy.$$escapeHtml(opt_data.dcDate)) : ''), '</div><p class="el8ItemWithDate">');
  el8.template.ptdata.model.dcMedOrder.orderSummary(soy.$$augmentData(opt_data.item, {hasTrigger: opt_data.hasActions}), output);
  output.append('</p></li>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.meds.addNewTrigger = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8LHSButtonContainer"><p><button type="button" class="el8button document_med_order_trigger el8ItemButton el8Show ebs-btn ebs-btn-default">+ Document Med Pt Is On</button>', (opt_data.bulkRefillEnabled) ? '<button type="button" class="el8button bulk_refill_med_order_trigger el8ItemButton el8Show ebs-btn ebs-btn-default" ' + ((opt_data.name) ? 'data-type="' + soy.$$escapeHtml(opt_data.name) + '"' : '') + '>+ Bulk Refill</button>' : '', '</p></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.meds.addNewAndCheckPMPTrigger = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<div class="el8LHSButtonContainer"><p><button type="button" class="el8button document_med_order_trigger el8ItemButton el8Show ebs-btn ebs-btn-default">+ Document Med Pt Is On</button>', (opt_data.bulkRefillEnabled) ? '<button type="button" class="el8button bulk_refill_med_order_trigger el8ItemButton el8Show ebs-btn ebs-btn-default" ' + ((opt_data.name) ? 'data-type="' + soy.$$escapeHtml(opt_data.name) + '"' : '') + '>+ Bulk Refill</button>' : '', (el8Globals.FEATURES.PMPCheck) ? '<button type="button" class="el8button check-pmp-trigger el8ItemButton el8Show ebs-btn ebs-btn-default" data-amplitude-source="perm-rx-meds-summary">Check PMP</button>' : '', '</p></div>');
  if (!opt_sb) return output.toString();
};


/**
 * @param {Object.<string, *>=} opt_data
 * @param {soy.StringBuilder=} opt_sb
 * @return {string|undefined}
 * @notypecheck
 */
el8.template.appchart.refpanel.meds.actionButton_ = function(opt_data, opt_sb) {
  var output = opt_sb || new soy.StringBuilder();
  output.append('<button tabindex="-1" type="button" class="el8button el8ActionButton ebs-btn ebs-btn-default">Actions<span class="el8ButtonDropdownIcon"></span></button>');
  if (!opt_sb) return output.toString();
};
